import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0acb8dee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-cen rel viewport" }

import { useRoute } from 'vue-router'
import DynamicIframe from '@/components/iframe/DynamicIframe.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DynamicIframe, {
      campaign: _ctx.$route.params.name,
      style: {"width":"100%"}
    }, null, 8, ["campaign"])
  ]))
}
}

})